'use client'

import { useCallback, useEffect } from 'react'
import { useQueryState } from 'nuqs'
import {
  clearPriceIntentAttributionForProduct,
  getPriceIntentAttributionForProduct,
  markPriceIntentAttributionForProduct,
  parseAsPriceIntentAttributionUserFlow,
  PRICE_INTENT_ATTRIBUTION_USER_FLOW_QUERY_PARAM,
} from '@/features/recommendations/priceIntentAttributionStorage'
import type { PriceIntentAttribution } from '@/services/priceIntent/priceIntent.types'

export function getPriceIntentAttributionField(productName: string) {
  const attribution = getPriceIntentAttributionForProduct(productName)
  return attribution ? { attribution } : {}
}

export function usePriceIntentAttribution() {
  const getPriceIntentAttributionFieldStable = useCallback(
    (productName: string) => getPriceIntentAttributionField(productName),
    [],
  )

  const clearAfterSuccessfulConfirm = useCallback((productName: string) => {
    clearPriceIntentAttributionForProduct(productName)
  }, [])

  return {
    getPriceIntentAttributionField: getPriceIntentAttributionFieldStable,
    clearAfterSuccessfulConfirm,
  }
}

export function useSyncPriceIntentAttributionFromUrl(productName: string) {
  const [userFlow, setUserFlow] = useQueryState(
    PRICE_INTENT_ATTRIBUTION_USER_FLOW_QUERY_PARAM,
    parseAsPriceIntentAttributionUserFlow,
  )

  useEffect(() => {
    if (userFlow == null) return

    const attribution: PriceIntentAttribution = { userFlow }
    markPriceIntentAttributionForProduct(productName, attribution)
    void setUserFlow(null)
  }, [productName, setUserFlow, userFlow])
}
